import { Component, OnInit, ViewChild, AfterViewChecked, AfterViewInit, ViewChildren, QueryList } from '@angular/core';
import { PublishersService } from "./publishers.service";
import { IEditPublisherViewModel, IPublisherInfoModel, IPublisherSettingsModel, IPublisherMappingsModel, CreatePublisherViewModel } from "./publisher.model";
import { DropdownValue } from "../shared/dropdown.model";
import { ClaimsService } from '../core/services/claims.service';
import { AuthService } from '../core/services';
import { PublisherSelectionComponent } from '../shared/publisher-selection.component';
import { PublisherInfoComponent } from './publisher-info-modal.component';
import { PublisherSettingsComponent } from './publisher-settings-modal.component';
import { PublisherMappingsComponent } from './publisher-mappings-modal.component';

@Component({
    moduleId: module.id,
    templateUrl: 'publishers.component.html'
})

export class PublishersComponent implements OnInit {
    private data: Array<IEditPublisherViewModel>;
    seletedPublisher: IEditPublisherViewModel;
    showOverlay: boolean = false;
    isSambaAdmin: boolean;

    private pubInfoModel: IPublisherInfoModel;
    private pubSettingsModel: IPublisherSettingsModel[];
    private pubMappingsModel: IPublisherMappingsModel[];

    @ViewChild("publisherInfoModal") publisherInfoModal: PublisherInfoComponent;
    @ViewChild("publisherSettingsModal") publisherSettingsModal: PublisherSettingsComponent;
    @ViewChild("publisherMappingsModal") publisherMappingsModal: PublisherMappingsComponent;
    @ViewChild("publisherSelector") publisherSelector: PublisherSelectionComponent;

    constructor(private publishersService: PublishersService, private claimsService: ClaimsService, private authService: AuthService) {
        this.isSambaAdmin = this.claimsService.getUserTypeId() === 1;
    }

    ngOnInit() {
        this.showOverlay = true;
        this.publishersService.getPublishers().subscribe(
            (res: any) => { this.data = <Array<IEditPublisherViewModel>>res.json(); },
            () => { },
            () => { this.showOverlay = false; }
        );
    }

    onPublisherValueChanged(item: DropdownValue) {
        if (item.value === 0) {
            this.seletedPublisher = null;
        } else {
            this.seletedPublisher = this.data.find(s => s.id === item.value);
        }
    }

    onPublisherInfoAdded(item: IPublisherInfoModel) {
        this.pubInfoModel = item;
        $('#publisherSettingsModal').modal('show');
    }

    onPublisherSettingsAdded(item: IPublisherSettingsModel[]) {
        this.pubSettingsModel = item;
        $('#publisherMappingsModal').modal('show');
    }

    onPublisherMappingsAdded(item: IPublisherMappingsModel[]) {
        this.pubMappingsModel = item;
        this.createPublisher();
    }

    private createPublisher() {
        this.showOverlay = true;

        let publisherViewModel = new CreatePublisherViewModel();
        publisherViewModel.groupId = this.pubInfoModel.groupId;
        publisherViewModel.name = this.pubInfoModel.name;
        publisherViewModel.requiresSignature = this.pubInfoModel.requiresSignature;
        publisherViewModel.showRatings = this.pubInfoModel.showRatings;
        publisherViewModel.signature = this.pubInfoModel.signature;
        publisherViewModel.color = this.pubInfoModel.color;
        publisherViewModel.publisherSettings = this.pubSettingsModel;
        publisherViewModel.publisherMappings = this.pubMappingsModel;

        this.publishersService.addPublisher(publisherViewModel).subscribe(
            respose => {
                let result = respose.json();
                this.data.push(result);
                //clear the modals
                this.publisherInfoModal.clearModal();
                this.publisherSettingsModal.clearModal();
                this.publisherMappingsModal.clearModal();
                //refresh filters with new publisher
                this.authService.getFilters().subscribe();
                //display the info for the new publisher
                this.seletedPublisher = this.data.find(s => s.id === result.id);
                this.publisherSelector.refreshItems(new DropdownValue(result.id, result.name));
                this.publisherSelector.setCurrentSelection(this.seletedPublisher.id);
            },
            () => { },
            () => { this.showOverlay = false; });
    }
}


// WEBPACK FOOTER //
// ./src/app/publishers/publishers.component.ts